import React from 'react';
import { Hero } from './components/Hero';
import { QuickProof } from './components/QuickProof';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
}
export function App({
  showUrgency = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white" data-id="element-0" data-mp="2wi5lndz38fn7">
      <main data-id="element-1" data-mp="28tmdcyg1g2v4">
        <Hero data-id="element-2" data-mp="28te3zgj4jfoo" />
        <QuickProof data-id="element-3" data-mp="28suveqfd63nb" />
        <Problem data-id="element-4" data-mp="28sbe9bxjfjac" />
        <Solution data-id="element-5" data-mp="23vcmh01cjofb" />
        <WhatYouGet data-id="element-6" data-mp="23w4fq47h1a2f" />
        <Bonuses data-id="element-7" data-mp="23ujjma5idj2g" />
        <Pricing showUrgency={showUrgency} data-id="element-8" data-mp="23v2rsz5cwt3a" />
        <Testimonials data-id="element-9" data-mp="3ik7jmqgv0tve" />
        <Guarantee data-id="element-10" data-mp="3iiwf2oflbi38" />
        <Faq data-id="element-11" data-mp="3ijfu9xduvsdk" />
        <FinalCta showUrgency={showUrgency} data-id="element-12" data-mp="3ihv2gfixenje" />
      </main>
      <Footer data-id="element-13" data-mp="3mkhlbqxmcy4g" />
    </div>;
}